import { useCallback } from 'react'
import ModalDeleteFilled from '../../../../../../../../baseComponents/ModalsLayouts/ModalDeleteFilled'
import { ModalEditComponentProps } from '../../../../../../../../baseComponents/ModalsLayouts/types'
import { twinFetchPostJSON } from '../../../../../../../../utils/globals/data'
import useTwinTranslation from '../../../../../../../../utils/hooks/useTwinTranslation'
import { getEmployeeQuickAccessParam } from '../../../../../../../../utils/reducers/getters'
import { changeEmployeeParams } from '../../../../../../../../utils/reducers/reduxDispatch'

interface ModalDeleteEmployeeQuickAccessProps extends ModalDeleteEmployeeQuickAccessLogicProps {}

export const ModalDeleteEmployeeQuickAccess: React.FC<ModalDeleteEmployeeQuickAccessProps> = ({ allRowData, onSubmit, setOpened }) => {
    const { t } = useTwinTranslation()
    const { beforeSubmitDelete } = useModalDeleteEmployeeQuickAccessLogic({ setOpened, onSubmit, allRowData })
    
    let translations = {
        title: t('sureUnableEmployeeQuickAccess', '¿Seguro quieres borrar este acceso rápido?'),
        subtitle: t('onceDeletedNotRecoverM', 'Una vez eliminado no podrás recuperarlo'),
    }
    
    return (<ModalDeleteFilled opened={true} setOpened={setOpened} onCancel={() => setOpened(null)} onAccept={beforeSubmitDelete} translations={translations} />)
}

interface ModalDeleteEmployeeQuickAccessLogicProps extends ModalEditComponentProps {}

const useModalDeleteEmployeeQuickAccessLogic = ({ setOpened, onSubmit, allRowData }: ModalDeleteEmployeeQuickAccessLogicProps) => {

    const beforeSubmitDelete = useCallback(async () => {
        const oldShortcuts = getEmployeeQuickAccessParam()
        let newShortcuts = []
        let order = 1
        for (const element of oldShortcuts) {
            if (element.id !== allRowData?.id) {
                newShortcuts.push({ ...element, order })
                order++
            }
        }
    
        const updatedShortcutsStr = JSON.stringify(newShortcuts)
        const result = await twinFetchPostJSON('/api/app/config/employee/updateEmployeeParameter', { parameterKey: 'employee_quick_access', value: updatedShortcutsStr })
        changeEmployeeParams({ 'employee_quick_access': updatedShortcutsStr })
        setOpened(null)
        onSubmit(result, newShortcuts)
    }, [setOpened, onSubmit, allRowData])

    return { beforeSubmitDelete, setOpened}
}


